import { render, staticRenderFns } from "./TestOrderLocation.vue?vue&type=template&id=6b0b1738&"
import script from "./TestOrderLocation.vue?vue&type=script&lang=js&"
export * from "./TestOrderLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports